import { Canvas, FabricObject, Polyline, Point } from 'fabric';

const snappingDistance = 10;

const polylineOptions = {
  stroke: 'red',
  strokeWidth: 1,
  selectable: false,
  evented: false,
  opacity: 0.8,
  fill: null
};

// El canvas usa el sistema de coordenadas DOM, no el plano cartesiano matemático.
// El origen (0,0) es la esquina superior izquierda del canvas.
// X crece hacia la derecha, Y crece hacia abajo.
// Esto es inverso al eje Y del plano cartesiano tradicional.

const createVerticalGuideline = (artboardHeight: number, x: number): Polyline => {
  const line = new Polyline(
    [
      { x, y: 0 }, // Punto superior (y=0 es el tope del artboard)
      { x, y: artboardHeight } // Punto inferior (y=artboardHeight es el borde inferior del artboard)
    ],
    polylineOptions
  );
  line.isGuideline = true;
  return line;
};

const createHorizontalGuideline = (artboardWidth: number, y: number): Polyline => {
  const line = new Polyline(
    [
      { x: 0, y }, // Punto izquierdo (x=0 es el borde izquierdo del artboard)
      { x: artboardWidth, y } // Punto derecho (x=artboardWidth es el borde derecho del artboard)
    ],
    polylineOptions
  );
  line.isGuideline = true;
  return line;
};

export const clearGuideLines = (canvas: Canvas) => {
  canvas.getObjects().forEach(obj => {
    if (obj.isGuideline) {
      canvas.remove(obj);
    }
  });
  canvas.requestRenderAll();
};

export const handleObjectMoving = (
  canvas: Canvas,
  obj: FabricObject,
  artboardWidth: number,
  artboardHeight: number
) => {
  const objCenter = obj.getCenterPoint(); // Retorna el centro del objeto (el x y el y del medio del objeto)
  let { x: centerX, y: centerY } = objCenter;

  const objLeft = centerX - obj.getScaledWidth() / 2; // borde izquierdo
  const objRight = centerX + obj.getScaledWidth() / 2; // borde derecho
  const objTop = centerY - obj.getScaledHeight() / 2; // borde superior
  const objBottom = centerY + obj.getScaledHeight() / 2; // borde inferior

  clearGuideLines(canvas);

  // Snap borde izquierdo del objeto → borde izquierdo del artboard
  if (Math.abs(objLeft) < snappingDistance) {
    centerX = obj.getScaledWidth() / 2;
    canvas.add(createVerticalGuideline(artboardHeight, 0));
  }
  // Snap borde derecho del objeto → borde derecho del artboard
  else if (Math.abs(objRight - artboardWidth) < snappingDistance) {
    centerX = artboardWidth - obj.getScaledWidth() / 2;
    canvas.add(createVerticalGuideline(artboardHeight, artboardWidth));
  }
  // Snap centro horizontal del objeto → centro horizontal del artboard
  else if (Math.abs(centerX - artboardWidth / 2) < snappingDistance) {
    centerX = artboardWidth / 2;
    canvas.add(createVerticalGuideline(artboardHeight, artboardWidth / 2));
  }

  // Snap borde superior del objeto → borde superior del artboard
  if (Math.abs(objTop) < snappingDistance) {
    centerY = obj.getScaledHeight() / 2;
    canvas.add(createHorizontalGuideline(artboardWidth, 0));
  }
  // Snap borde inferior del objeto → borde inferior del artboard
  else if (Math.abs(objBottom - artboardHeight) < snappingDistance) {
    centerY = artboardHeight - obj.getScaledHeight() / 2;
    canvas.add(createHorizontalGuideline(artboardWidth, artboardHeight));
  }
  // Snap centro vertical del objeto → centro vertical del artboard
  else if (Math.abs(centerY - artboardHeight / 2) < snappingDistance) {
    centerY = artboardHeight / 2;
    canvas.add(createHorizontalGuideline(artboardWidth, artboardHeight / 2));
  }

  obj.setPositionByOrigin(new Point(centerX, centerY), 'center', 'center');
  canvas.requestRenderAll();
};
